import React from 'react';
// import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import {Routes, Route,Link} from 'react-router-dom';

import Dashboard from '../containers/Student/Dashboard';
import Login from '../containers/Auth/Login';
import Register from '../containers/Auth/Register';
import ForgotPassword from '../containers/Auth/ForgotPassword';
import ResetPassword from '../containers/Auth/ResetPassword';
import ChangePassword from '../containers/Auth/ChangePassword';
import AddProfile from '../containers/Student/AddProfile';
// import EditProfile from '../containers/Student/EditProfile';
import MyTransaction from '../containers/Student/MyTransaction';
import Result from '../containers/Student/Result';
import ResultPdf from '../containers/Student/ResultPdf';
import Notification from '../containers/Notification/Index';
import Scholarships from '../containers/Student/Scholarship';
import BankTransfer from '../containers/FeeModule/BankTransfer';
import StudyMaterial from '../containers/Student/StudyMaterial';
import Enrollment from '../containers/Student/Enrollment';
import GeneratePassword from '../containers/Auth/GeneratePassword';
import AutoLoginDashboard from '../containers/Auth/AutoLoginDashboard'
import AmbassadorLogin  from '../containers/Ambassador/AmbassadorLogin';
import AmbassadorDashobard from '../containers/Ambassador/AmbassadorDashboard';
import AddNewStudent from '../containers/Ambassador/AddNewStudent';
import AmbassadorForgotPassword from '../containers/Ambassador/AmbassadorForgotPassword';
import AmbassadorResetPassword from '../containers/Ambassador/AmbassadorResetPassword';
import AmbassadorChangePassword from '../containers/Ambassador/AmbassadorChangePassword';
import ViewQrCode from '../containers/Ambassador/ViewQrCode';
import BulkOnBoard from '../containers/Ambassador/BulkOnBoard';
import AmbReffralRegister from '../containers/Auth/AmbReferralRegister';
import ReferToFriend from '../containers/Student/ReferToFriend';
import FriendRegister from '../containers/Auth/FriendRegister';
import BankDetail from '../containers/Student/BankDetail';
import MastercardPaymentSuccessful from '../containers/Student/MastercardPaymentSuccessful';
import CCAvenuePaymentStatus from '../containers/Student/CCAvenuePaymentStatus';
import UpayPaymentSuccessful from '../containers/Student/UpayPaymentSuccessful';
import BankDhofarPaymentStatus from '../containers/Student/BankDhofarPaymentStatus'
function Layout(){

    return(
        <>
            {/* <Header/> */}
            <Routes>
                <Route path="/" element={<Login/>}/>
                <Route path="/login" element={<Login/>}/>
                <Route path="/register" element={<Register/>}/>
                <Route path="/forgot-password" element={<ForgotPassword/>}/>
                <Route path="/password/reset" element={<ResetPassword/>}/>
                {/* <Route path="/add-profile" element={<AddProfile/>}/> */}
                <Route path="/change-password" element={<ChangePassword/>}/>
                {/* <Route path="/edit-profile/:id" element={<EditProfile/>}/> */}
                <Route exact path="/my-transactions/:id" element={<MyTransaction/>}/>
                <Route exact path="/ccavenue-payment-status/:status" element={<CCAvenuePaymentStatus/>}/>
                <Route exact path="/bankdhofar-payment-status/:status" element={<BankDhofarPaymentStatus/>}/>
                <Route path="/result" element={<Result/>}/>
                <Route path="/pdf-download" element={<ResultPdf/>}/>
                <Route path="/notifications" element={<Notification/>}/>
                {/* <Route path="/scholarships" element={<Scholarships/>}/> */}
                <Route path="/dashboard" element={<Dashboard/>}/>
                <Route path="/refer-a-friend" element={<ReferToFriend/>}/>
                <Route path="/referral-register" element={<FriendRegister/>}/>
                <Route path="/amb-referral-register" element={<AmbReffralRegister/>}/>
                <Route path="/bank-transfer" element={<BankTransfer/>}/>
                <Route path="/bank-detail/:id" element={<BankDetail/>}/>
                <Route path="/payment-successfull/:id/:paytype/" element={<MastercardPaymentSuccessful/>}/>
                <Route path="/upay-payment-successfull/:id/:paytype/" element={<UpayPaymentSuccessful/>}/>
                {/* <Route path="/study-material-delivery-address" element={<StudyMaterial/>}/> */}
                <Route path="/generate-password" element={<GeneratePassword/>}/>
                <Route path="/user-dashboard" element={<AutoLoginDashboard/>}/>
                <Route path="/ambassador" element={<AmbassadorLogin/>}/>
                <Route path="/ambassador/login" element={<AmbassadorLogin/>}/>
                <Route path="/ambassador/dashboard" element={<AmbassadorDashobard/>}/>
                <Route path="/ambassador/forgot-password" element={<AmbassadorForgotPassword/>}/>
                <Route path="/ambassador/password/reset" element={<AmbassadorResetPassword/>}/>
                <Route path="/ambassador/change-password" element={<AmbassadorChangePassword/>}/>
                <Route path="/ambassador/add-new-student" element={<AddNewStudent/>}/>
                <Route path="/ambassador/view-qr-code" element={<ViewQrCode/>}/>
                <Route path="/ambassador/bulk-onboard" element={<BulkOnBoard/>}/>

                <Route
                    path="*"
                    element={
                    <main style={{ padding: "1rem" , textAlign: "center"}}>
                    <h2>Page not found </h2>
                    <Link to="/">Back to Home</Link>

                    </main>
                    }
                />
            </Routes>
            <Footer/>
        </>
    );
}

export default Layout;